import { css } from "@linaria/core";

export const labelOrderColumn = css`
  text-align: center;
  min-width: 2rem;
  font-variant-numeric: tabular-nums;
`;
